<template>
  <div>
    <div class="title-container">
      <button
        class="hamburger-btn"
        aria-label="Open menu"
        @click="toggleMobile()"
      >
        <span /><span /><span />
      </button>
      <p>
        {{ title }}
      </p>
      <div class="beta-badge">
        beta
      </div>
      <button 
        class="run-demo-btn"
        title="Start the interactive tutorial"
        @click="handleRunDemo"
      >
        <span class="run-demo-icon">▶</span>
        Run Demo
      </button>
      <Avatar 
        icon="pi pi-user" 
        class="profile-photo" 
        size="xlarge" 
        shape="circle"  
        data-test="profile-btn"
        @click="openUserProfile()"  
      />
    </div>
  </div>
</template> 

<script>

import { Avatar } from "primevue";
import eventEmitter from '@/utils/eventEmitter';

export default {
  name: "MainTitle",
  components: {
    Avatar
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: "" 
    } 
  },
  methods: {
    openUserProfile() {
      this.$router.push({ path: "/userprofile" });
    },
    handleRunDemo() {
      if (window.innerWidth <= 599) return;
      eventEmitter.emit('run-demo');
    }
  }

}
</script>

<script setup>
  import { sidebarWidth, toggleMobileSidebar } from '../sidebar/state';
  const width = sidebarWidth;
  const toggleMobile = toggleMobileSidebar;
</script>

<style scoped>
.profile-photo {
    position: fixed;
    top: 0;
    right: 0;
    margin: 3px;
    height: 40px;
    width: 40px;
    background: var(--color-surface);
    border: 1.5px solid rgba(27,30,100,0.25);
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.profile-photo:hover {
    background: var(--color-surface-raised);
    box-shadow: var(--shadow-sm);
    transform: scale(1.05);
}

.title-container {
  position: fixed;
  top: 0;
  right: 0;
  margin-bottom: 70px;
  background: var(--color-bg);
  border-bottom: 2px solid rgba(27,30,100,0.18);
  height: 48px;
  display: flex;
  align-items: center;
  z-index: 1;
  width: calc(100vw - v-bind(width))
}

@media (max-width: 599px) {
  .title-container p {
    font-size: 20px !important;
  }
  
}

.title-container p {
  color: var(--color-primary);
  font-family: var(--font-family);
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin: 0;
  width: 100%;
  text-align: center;
}


.span-parent {
  position: relative;
  width:100% !important;
}

.beta-badge {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--color-primary);
  border: none;
  color: var(--color-text-on-dark);
  padding: 2px 14px;
  font-style: italic;
  font-weight: 700;
  font-family: var(--font-family);
  border-radius: var(--radius-full);
  font-size: 0.78rem;
  letter-spacing: 0.8px;
  z-index: 10;
}

@media (max-width: 599px) {
  .beta-badge {
    left: 10px;
    width: 50px;
    padding: 2px 10px;
  }
}

.run-demo-btn {
  position: absolute;
  right: 52px;
  top: 0;
  bottom: 0;
  background: var(--gradient-aurora);
  color: var(--color-text-on-dark);
  border: none;
  padding: 0 16px;
  font-weight: 600;
  font-family: var(--font-family);
  border-radius: 0;
  font-size: 0.8rem;
  cursor: pointer;
  z-index: 10;
  transition: opacity var(--transition-fast);
  display: flex;
  align-items: center;
  gap: 5px;
}

.run-demo-btn:hover {
  opacity: 0.88;
}

.run-demo-btn:active {
  opacity: 0.75;
}

.run-demo-icon {
  font-size: 0.7rem;
}

@media (max-width: 599px) {
  .run-demo-btn {
    display: none;
  }
}

.hamburger-btn {
  display: none;
}

@media (max-width: 599px) {
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    position: absolute;
    left: 10px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px 7px;
    z-index: 10;
    border-radius: 6px;
    transition: background 0.2s;
  }
  .hamburger-btn:hover {
    background: rgba(30, 37, 87, 0.08);
  }
  .hamburger-btn span {
    display: block;
    width: 20px;
    height: 2px;
    background: var(--color-primary);
    border-radius: 2px;
  }
  .beta-badge {
    display: none;
  }
}

</style>